import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { WA_PHYSICS } from '../core/constants';
import { computeSafeSpawnPosition } from './spawnHelper';

export const WeaponGrenade: WeaponDefinition = {
  id: 'grenade',
  name: 'Grenade',
  icon: 'grenade.png',
  category: 'thrown',
  maxAmmo: -1,
  maxUsesPerTurn: 1,
  powerCharging: true,
  timerAdjustable: true,
  timerRange: [1, 5],
  showAimGuide: true,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, timer, world } = ctx;

    const maxSpeed = 750;
    const speed = (power / 100) * maxSpeed;
    const rad = (angle * Math.PI) / 180;

    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;

    const spawnDistance = 20;
    const spawn = computeSafeSpawnPosition(worm, aimRad, spawnDistance, world);

    const grenade = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'grenade',
      timer: timer,
      bounceH: WA_PHYSICS.GRENADE.BOUNCE_HORIZONTAL,
      bounceV: WA_PHYSICS.GRENADE.BOUNCE_VERTICAL,
      friction: WA_PHYSICS.GRENADE.FRICTION,
      windAffected: false,
      explosionRadius: WA_PHYSICS.GRENADE.EXPLOSION_RADIUS,
      maxDamage: WA_PHYSICS.GRENADE.MAX_DAMAGE,
      ownerId: worm.id,
    });

    return {
      success: true,
      entities: [grenade],
    };
  },
};
